var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00008 1.3335L12.0001 1.3335C12.7365 1.3335 13.3334 1.93045 13.3334 2.66683V6.00016C13.3334 6.73654 12.7365 7.3335 12.0001 7.3335L4.00008 7.3335C3.2637 7.3335 2.66675 6.73654 2.66675 6.00016L2.66675 2.66683C2.66675 1.93045 3.2637 1.3335 4.00008 1.3335ZM12.0001 2.66683V6.00016L4.00008 6.00016L4.00008 2.66683L12.0001 2.66683ZM4.00008 8.66683L12.0001 8.66683C12.7365 8.66683 13.3334 9.26378 13.3334 10.0002V13.3335C13.3334 14.0699 12.7365 14.6668 12.0001 14.6668L4.00008 14.6668C3.2637 14.6668 2.66675 14.0699 2.66675 13.3335L2.66675 10.0002C2.66675 9.26378 3.2637 8.66683 4.00008 8.66683ZM12.0001 13.3335V10.0002L4.00008 10.0002V13.3335L12.0001 13.3335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvView);
export default __webpack_public_path__ + "static/media/adv-view.a351b45b5a0b6cb79a18f564ed36559c.svg";
export { ForwardRef as ReactComponent };